import React from 'react'

function Submissions() {
  return (
    <center><div className='mt-44 text-2xl'>Coming Soon 🔜</div></center>
  )
}

export default Submissions